import { Template, LazyTemplate } from "../../core/template/index";
import { View } from "../../core/view";
import { JobEntry, JobTaskEntry, JobTaskEntryDetail } from "../../app/datatypes";
import ConfirmModal from "../../core/modals/confirm/index";
import OrderItem, { OrderItemLike } from "../../app/db/models/orderItem";
import { ModalResultType } from "../../core/modal/index";
import { ClientAction } from "../../app/synchronizer/index";
import { SyncMessage } from "../../core/db/models/synchronizer";
import { User } from "../../core/db/models/index";
import OrderItemOverviewModal, { OrderItemOverviewViewData } from "../../modals/orderItemOverview/index";
import moment from 'moment';
import { StringOrNumber } from "../../core/helpers/types";
import { ValtasiirtoBaseApp } from "../../app/valtaSiirtoBaseApp";
import OrderItemAssignment, { OrderItemAssignmentLike } from "../../app/db/models/orderItemAssignment";
import Order from "../../app/db/models/order";
import MessageModal from "../../core/modals/message";

export default class OrderItemFlipcardView extends View
{
    public template = Template.lazy('/views/orderItemFlipcard/index.html');   
    public data: OrderItemFlipcardViewData;
    public app: ValtasiirtoBaseApp;

    private startButton: HTMLButtonElement;
    private stopButton: HTMLButtonElement;
    private cancelButton: HTMLButtonElement;
    private overviewButton: HTMLButtonElement;

    private getAssignedUsernames()
    {
        return this.data.assignments.map(o => (o.user as User).username);
    }

    private canCancelOrStop()
    {
        if (this.data.state === OrderItem.STATE_STARTED)
        {
            return (this.data.assignments[0].user as User).id === this.app.user.id;
        }
        
        return false;
    }

    private get isLate(): boolean
    {
        console.log(this.data.order.items)
        return OrderItemAssignment.isLate(this.data.order, this.data, this.data.assignments[0]);
    }

    private get forceFaultCode(): boolean
    {
        let orderStartTime = Order.startTime(this.data.order);
        let orderEndTime = Order.endTime(this.data.order);

        let assignments: OrderItemAssignmentLike[] = [];

        for (let item of this.data.order.items)
        {
            if (item.assignments.length > 0)
            {
                assignments.push(item.assignments[0]);
            }
        }
        
        assignments.sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());

        let firstStartTime = new Date(assignments[0].start_time);
        let lastendTime = new Date(assignments[assignments.length - 1].end_time);

        // Milliseconds, if positive = started late
        let startDiff = firstStartTime.getTime() - orderStartTime.getTime();
        let endDiff = lastendTime.getTime() - orderEndTime.getTime();

        // Minutes to millisconds
        let treshold = this.app.constance.ORDER_ITEM_IS_LATE_THRESHOLD * 60 * 1000;

        let result =  startDiff >= treshold || endDiff >= treshold;


        /* console.log({
            '1. orderStartTime': orderStartTime,
            '2. firstStartTime': firstStartTime,
            '3. orderEndTime': orderEndTime,
            '4. lastendTime': lastendTime,
            '5. isLate': firstStartTime > orderStartTime || lastendTime > orderEndTime,
            '6. result': result,
            '7.startDiff': startDiff,
            '8. endDiff': endDiff,
            '9. treshold': treshold
        }); */

        return result;
    }

    public beforeRender(): PromiseLike<void>
    {
        console.log(this.data.assignments)
        this.data.isAssignedToCurrentUser = this.data.assignments.find(o => o.user_id == this.app.user.id) != null;
        this.data.canBeAssigned = this.data.state === OrderItem.STATE_NEW || (this.data.state === OrderItem.STATE_STARTED && !this.data.isAssignedToCurrentUser);
        this.data.canBeStoppedOrCancelledByCurrentUser = this.data.isAssignedToCurrentUser && this.data.assignments.find(o => o.user_id == this.app.user.id && o.end_time != null) == null;
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        this.startButton = this.element.querySelector('#takeOrJoinOrderItem') as HTMLButtonElement;
        this.stopButton = this.element.querySelector('#stopButton') as HTMLButtonElement;
        this.cancelButton = this.element.querySelector('#cancelButton') as HTMLButtonElement;
        this.overviewButton = this.element.querySelector('#overviewButton') as HTMLButtonElement;

        if (this.data.state === OrderItem.STATE_STARTED)
        {
            const updateTimer = () =>
            {
                for(var assignment of this.data.assignments)
                {
                    if (assignment.end_time == null)
                    {
                        this.data[`loaderTimer_${assignment.user_id}`] = this.filters.timespan(assignment.start_time);
                    }
                }
            }

            setInterval(updateTimer, 1000);
            updateTimer();
        }
        
        return super.afterRender();
    }

    // Bound in template (data-bind-click="onStartButtonClick")
    public onStartButtonClick(e: MouseEvent)
    {
        this.helpers.setButtonEnabled(this.startButton, false);
        e.stopPropagation();

        let modal = new ConfirmModal(this.pgettext('Order item message', 'Are you sure you want start working on this order item?'));
        
        this.app.actions.confirmAndPush(modal, {
            action: ClientAction.ORDER_ITEM_START,
            data: {
                user_id: this.app.user.id,
                order_item_id: this.data.id,
                start_time: new Date()
            }
        }).then(() =>
        {
            this.app.toasts.show(this.pgettext('Order item message', 'Order item successfully started!'));
            this.app.refreshCurrentView();
        }, () => { this.helpers.setButtonEnabled(this.startButton, true);});
    }

    // Bound in template (data-bind-click="onCancelButtonClick")
    public onCancelButtonClick(e: MouseEvent)
    {
        this.helpers.setButtonEnabled(this.cancelButton, false);
        e.stopPropagation();

        let modal = new ConfirmModal(this.pgettext('Order item message', 'Are you sure you want to cancel working on this order item?'));
        this.app.actions.confirmAndPush(modal, {
            action: ClientAction.ORDER_ITEM_CANCEL_START,
            data: {
                user_id: this.app.user.id,
                order_item_id: this.data.id,
                end_time: new Date()
            }
        }).then(() =>
        {
            this.app.toasts.show(this.pgettext('Order item message', 'Order item successfully cancelled!'));
            this.app.refreshCurrentView();
        }, () => {this.helpers.setButtonEnabled(this.cancelButton, true);});
    }

    // Bound in template (data-bind-click="onStopButtonClick")
    public onStopButtonClick(e: MouseEvent)
    {
        this.helpers.setButtonEnabled(this.stopButton, false);
        e.stopPropagation();
        console.log(this.data.order.items)

        let modal = new ConfirmModal(this.pgettext('Order item message', 'Are you sure you want to mark this order item as completed?'));
        
        this.app.actions.confirmAndPush(modal, {
            action: ClientAction.ORDER_ITEM_COMPLETE,
            data: {
                user_id: this.app.user.id,
                order_item_id: this.data.id,
                end_time: new Date()
            }
        }).then(() =>
        {
            this.app.toasts.show(this.pgettext('Order item message', 'Order item successfully completed!'));


            // If there are no order items that are not completed = the last order item was just completed
            this.app.db.OrderItem
                .where('order_id')
                    .equals(this.data.order.id)
                .and(o => o.state !== OrderItem.STATE_COMPLETED)
                .count()
            .then((unCompletedCount) =>
            {
                if (unCompletedCount === 0)
                {
                    location.href = '#/orders/';
                }
                else
                {
                    this.app.refreshCurrentView();
                }
            });
        }, () => { this.helpers.setButtonEnabled(this.stopButton, true);});
    }

    public onInfoButtonClick(e: MouseEvent)
    {
        this.helpers.setButtonEnabled(this.overviewButton, false);
        e.stopPropagation();

        let data: OrderItemOverviewViewData = this.data.assignments.find(o => o.user_id == this.app.user.id);

        data.forceFaultCode = this.forceFaultCode;

        let modal = new OrderItemOverviewModal(data);

        this.app.modals.show(modal).then(() =>
        {

        }).then(() =>
        {
            if (modal.result.type === ModalResultType.SAVE)
            {
                this.app.toasts.show(this.pgettext('Order item message', 'Successfully updated order item details!'));
                this.app.refreshCurrentView();
            }

            this.helpers.setButtonEnabled(this.overviewButton, true);
        });
    }

    public onOrderInternalMessageButtonClick(e: MouseEvent) {
        e.preventDefault();
        e.stopPropagation();

        const modal = new MessageModal(
            this.data.order.internal_message,
            this.pgettext('Order', 'Internal message'),
        );

        this.app.modals.show(modal);
    }
}

export interface OrderItemFlipcardViewData extends OrderItemLike
{
    itemTimer: string;
    timerMessage: string;
    isAssignedToCurrentUser?: boolean;
    canBeStoppedOrCancelledByCurrentUser?: boolean;
    canBeAssigned?: boolean;
}